export function joinDocumentTitle(
  ...segments: Array<string | undefined>
): string {
  return segments
    .filter((it) => it !== undefined && it.trim().length > 0)
    .join(" | ");
}
